// Module
var code = "<template>\n  <h1>${header}</h1>\n</template>\n";
// Exports
export default code;